module.exports = __webpack_public_path__ + "static/img/img-install-tag-bus-bottom-detail.a1646c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/install-guide/img-install-tag-bus-bottom-detail.svg
// module id = 1782
// module chunks = 1